"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hyperLink = _interopRequireDefault(require("../hyper-link/hyper-link"));

const Button = props => {
  const {
    children,
    Link,
    link,
    className,
    onClick,
    href
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["children", "Link", "link", "className", "onClick", "href"]);
  return href ? /*#__PURE__*/_react.default.createElement(_hyperLink.default, (0, _extends2.default)({}, otherProps, {
    href: href,
    link: Link || link,
    className: (0, _classnames.default)('btn', className)
  }), children) : /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: (0, _classnames.default)('btn', className),
    onClick: onClick
  }, children);
};

Button.propTypes = {
  children: _propTypes.default.node,
  Link: _propTypes.default.func,
  link: _propTypes.default.func,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  href: _propTypes.default.string
};
Button.defaultProps = {
  children: null,
  Link: null,
  link: null,
  className: '',
  onClick: () => {},
  href: null
};
var _default = Button;
exports.default = _default;